import View from "./view";
import Presenter from "./presenter";
import { ConnectComponent2 } from "util";

const states = [
  {
    name: "app.registration.optional_group.info",
    url: "/:optionalGroupUuid/ver",
    views: {
      "content@app": ConnectComponent2(View, Presenter)
    }
  }
];

export { states };



// WEBPACK FOOTER //
// ./src/components/app/registration/optional-groups/info/index.js